import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('b-container', {
    attrs: {
      "fluid": "lg"
    }
  }, [_c('div', {
    staticClass: "pageTitle mx-1"
  }, [_vm._v("空拍比對資料下載")]), _c('div', {
    staticClass: "borderColor mb-3"
  }, [_c('div', {
    staticClass: "d-flex align-items-center flex-wrap m-2"
  }, [_c('div', {
    staticClass: "mx-2 mr-4 my-2"
  }, [_vm._v(" 案場: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.searchInput,
      expression: "searchInput"
    }],
    staticClass: "filterInput ml-2",
    attrs: {
      "type": "text",
      "name": "factoryNameInput",
      "list": "factoryList",
      "placeholder": "案場名稱"
    },
    domProps: {
      "value": _vm.searchInput
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.searchInput = $event.target.value;
      }
    }
  }), _c('datalist', {
    attrs: {
      "id": "factoryList"
    }
  }, _vm._l(_vm.filteredFactoryInfo, function (i, idx) {
    return _c('option', {
      key: idx,
      domProps: {
        "value": i.factory + '_' + i.factoryId
      }
    });
  }), 0)]), _c('div', {
    staticClass: "ml-2 mr-4 my-2"
  }, [_vm._v(" 日期: "), _c('date-picker', {
    staticClass: "ml-2",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "date",
      "value-type": "format",
      "format": "YYYY-MM-DD",
      "placeholder": "請選擇日期",
      "disabled-date": _vm.isDateAfterToday
    },
    model: {
      value: _vm.selectedDate,
      callback: function callback($$v) {
        _vm.selectedDate = $$v;
      },
      expression: "selectedDate"
    }
  })], 1), _c('div', {
    staticClass: "ml-2 mr-4 my-2"
  }, [_vm._v(" 時間: "), _c('date-picker', {
    staticClass: "ml-2",
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "type": "time",
      "value-type": "HH:mm",
      "format": "HH:mm",
      "placeholder": "請選擇分鐘"
    },
    model: {
      value: _vm.selectedTime,
      callback: function callback($$v) {
        _vm.selectedTime = $$v;
      },
      expression: "selectedTime"
    }
  })], 1), _c('div', {
    staticClass: "mx-2 my-2 btnWrap"
  }, [_c('button', {
    staticClass: "confirmButton p-1",
    class: {
      disableButton: _vm.loadingData
    },
    staticStyle: {
      "width": "120px"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v(" 查詢 ")])]), _c('div', {
    staticClass: "mr-2 my-2 btnWrap"
  }, [_c('button', {
    staticClass: "confirmButton p-1",
    class: {
      disableButton: !_vm.previewData.length
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "id": "aerialDownloadBtn"
    },
    on: {
      "click": _vm.downloadCsv
    }
  }, [_vm._v(" 下載 ")]), _c('b-tooltip', {
    attrs: {
      "target": "aerialDownloadBtn",
      "triggers": "hover",
      "placement": "top",
      "container": "body",
      "disabled": !!_vm.previewData.length
    }
  }, [_vm._v(" 請先查詢資料 ")])], 1)])]), _c('div', {
    staticClass: "borderColor mb-4"
  }, [_c('div', {
    staticClass: "tableContent"
  }, [_c('div', {
    staticClass: "d-flex text-center border tableTitle"
  }, [_c('div', {
    staticStyle: {
      "width": "16%"
    }
  }, [_vm._v("INV")]), _c('div', {
    staticStyle: {
      "width": "16%"
    }
  }, [_vm._v("PV")]), _c('div', {
    staticStyle: {
      "width": "17%"
    }
  }, [_vm._v("絕緣阻值")]), _c('div', {
    staticStyle: {
      "width": "17%"
    }
  }, [_vm._v("PV電壓")]), _c('div', {
    staticStyle: {
      "width": "17%"
    }
  }, [_vm._v("PV電流")]), _c('div', {
    staticStyle: {
      "width": "17%"
    }
  }, [_vm._v("RA值")])]), _vm._l(_vm.previewData, function (row, idx) {
    return _c('div', {
      key: idx,
      staticClass: "d-flex text-center border-bottom dataRow"
    }, [_c('div', {
      staticStyle: {
        "width": "16%"
      }
    }, [_vm._v(_vm._s(row.inv))]), _c('div', {
      staticStyle: {
        "width": "16%"
      }
    }, [_vm._v(_vm._s(row.pv))]), _c('div', {
      staticStyle: {
        "width": "17%"
      }
    }, [_vm._v(_vm._s(_vm.showVal(row.insulation)))]), _c('div', {
      staticStyle: {
        "width": "17%"
      }
    }, [_vm._v(_vm._s(_vm.showVal(row.pvVoltage)))]), _c('div', {
      staticStyle: {
        "width": "17%"
      }
    }, [_vm._v(_vm._s(_vm.showVal(row.pvCurrent)))]), _c('div', {
      class: [row.ra !== null && (row.ra > 100 || row.ra < 80) ? 'raWarning' : ''],
      staticStyle: {
        "width": "17%"
      }
    }, [_vm._v(" " + _vm._s(_vm.showVal(row.ra)) + " ")])]);
  })], 2)])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };